<template>
    <v-container fluid pl-1 pr-1 pb-0 pt-0>

        <v-card light
                class="mx-auto"
                outlined
                elevation="10"
        >

            <v-row>
                <div class="overline ml-7 pt-3" id="app-search-header"><b>{{ $t('search.searchTitle') }} </b>
                    <v-icon :title="$t('search.searchPopupTitle')" right @click="showPopupSearch=true">mdi-information
                    </v-icon>
                </div>
            </v-row>


            <v-row class="pl-4 pr-3 mb-0 mt-0 pb-0 pt-0">
                <v-col cols="9"
                       xl="10"
                       lg="10"
                       md="10"
                       sm="10"
                       xs="9"
                >
                    <!-- note: keypress / input is buggy in mobile android browsers: use keydown event instead-->
                    <v-autocomplete outlined
                                    :label="$t('search.sampleLabel')"
                                    solo
                                    :hide-no-data="false" class="pl-1 pr-2 pt-1"
                                    @keydown="search"
                                    :filter="filterAbbreviations"
                                    @change="updateSearchTerm($event); retrieveResult"
                                    @click:clear="clearSearchTerm"
                                    :items="searchSuggestions"
                                    :search-input.sync="searchTerm"
                                    clearable
                                    prepend-inner-icon="mdi-magnify"
                                    append-icon=""
                                    :menu-props="searchFieldProps"
                                    hide-selected
                    >
                    </v-autocomplete>
                </v-col>
                <v-col cols="3"
                       xl="2"
                       lg="2"
                       md="2"
                       sm="2"
                       xs="3"
                >
                    <v-card-actions class="mt-0 pt-1">

                        <!--                        <v-btn small-->
                        <!--                               left-->
                        <!--                               class="app-search-bar-button mt-0"-->
                        <!--                               width="60%"-->
                        <!--                               :color=red @click="retrieveResult"-->
                        <!--                               :title="$t('title.searchSpecies')">{{ $t('search.search') }}-->

                        <!--                        </v-btn>-->

                        <v-btn small
                               class="app-search-bar-button mt-0"

                               :color="grey"
                               @click="expandSearchSettings"
                               :title="$t('title.searchSettings')">
                            <v-icon right>mdi-filter-menu</v-icon>
                            <div v-if="!isMobile()"> {{ $t('search.filter') }}</div>
                        </v-btn>
                    </v-card-actions>
                </v-col>


            </v-row>

        </v-card>

        <v-card v-if="showSearchSettings" style="background-color: #f2f2f2">
            <v-row>
                <div class="overline ml-7 pt-3"><b>{{ $t('search.expandSettings') }} </b>
                </div>
            </v-row>
            <br>

            <!--  TODO: @Andrin -> decide on language filter options -->
            <!--            <v-autocomplete-->
            <!--                    v-if="isFungusApp"-->
            <!--                    class="pl-4 pr-4 pb-1"-->
            <!--                    v-model="selectedLanguages"-->
            <!--                    :items="languageOptions.map(l => l.label)"-->
            <!--                    dense-->
            <!--                    chips-->
            <!--                    small-chips-->
            <!--                    deletable-chips-->
            <!--                    :color=red-->
            <!--                    :label="$t('search.selectLanguages')"-->
            <!--                    multiple-->
            <!--                    append-icon=""-->
            <!--            ></v-autocomplete>-->


            <v-autocomplete
                    v-if="isLichenApp"
                    class="pl-4 pr-4"
                    v-model="selectedEcotypes"
                    :items="ecotypeOptions.map(function(e) {return { text: e.label, value: e.id }})"
                    dense
                    chips
                    small-chips
                    deletable-chips
                    :color=red
                    :label="$t('search.selectEcotypes')"
                    multiple
                    append-icon=""
                    outlined
            />

            <v-row class="px-7" id="selected-search-timerange">
                <div class="overline" id="app-selected-timerange-header"><b>{{ $t('search.selectedTimeWindow') }}</b>
                    <app-highlighted-text> {{this.$store.state.yearRange.min}}-{{this.$store.state.yearRange.max}}
                    </app-highlighted-text>
                </div>
            </v-row>

            <v-row class="pl-5 pr-7 mb-0 mt-0 pb-0 pt-0">
                <v-range-slider
                        dark
                        v-model="timeSlider"
                        :thumb-color=red
                        thumb-label="always"
                        :track-color=orange
                        :color=red
                        :max=max
                        :min=min
                        hide-details="true"
                />
            </v-row>

            <search-color-legend></search-color-legend>

        </v-card>

        <app-popup
                :title="$t('search.searchPopupTitle')"
                :text="$t('search.searchPopupDescription')  + (isFungusApp ? `<br><br><img src='./assets/img/filter_fungus.PNG' width='100%' alt='Filter info'>` : `<br><br><img src='./assets/img/filter_lichen.PNG' width='100%' alt='Filter info'>` ) +  $t('search.searchPopupDescriptionAbbreviation') + (isFungusApp ?  `<br><br><img src='./assets/img/infopopup_fungus.PNG' width='100%' alt='Search info'>` + $t('search.searchPopupExampleFungus')  :  `<br><br><img src='./assets/img/infopopup_lichen.PNG' width='100%' alt='Search info'>` + $t('search.searchPopupExampleLichen') + $t('search.searchPopupLichenicolousFungi'))"
                :showPopup.sync="showPopupSearch"
                @cancel="showPopupSearch=false"
        />


    </v-container>
</template>

<script>
    import AppPopup from '../AppComponents/AppPopupDialog'
    import AppHighlightedText from '../AppComponents/AppHighlightedText'
    import SearchColorLegend from './SearchColorLegend'
    import axios from 'axios'
    import debounce from 'lodash/debounce'
    import {speciesUrl} from '../../data/app-data'
    import {API_ERROR_MESSAGE, TIME_RANGE} from '../../data/constants'
    import {COLOR_SCHEME} from '../../data/constants'
    import i18n from '../../plugins/i18n'


    export default {
        name: 'SearchWindow',
        components: {
            AppPopup,
            AppHighlightedText,
            SearchColorLegend
        },
        data() {
            return {
                languageOptions: [
                    {id: 'de', label: i18n.t('search.selectDE')},
                    {id: 'fr', label: i18n.t('search.selectFR')},
                    {id: 'it', label: i18n.t('search.selectIT')},
                ],
                selectedLanguages: [],
                ecotypeOptions: null, // TODO: @Silvia: implicitely include U if all selected ?
                selectedEcotypes: [],
                showPopupSearch: false,
                showSearchSettings: false,
                hover: false,
                searchTerm: '',
                timeSlider: [this.$store.state.yearRange.min, this.$store.state.yearRange.max],
                querySpeciesResult: null,
                queryIdResult: null,
                min: TIME_RANGE.min,
                max: TIME_RANGE.max,
                lightgreen: COLOR_SCHEME.app_lightyellow,
                red: COLOR_SCHEME.app_dark_red,
                orange: COLOR_SCHEME.app_light_red,
                grey: COLOR_SCHEME.app_lightgrey,
                searchSuggestions: [this.$i18n.t('search.noDataMessage')], // in order to avoid the 'no data available' which might be confusing
            }
        },
        computed: {
            taxonName: {
                get() {
                    return this.$store.state.taxonName
                },
                set(value) {
                    this.$store.commit('setTaxonName', value)
                }
            },
            yearRangeMin: {
                get() {
                    return this.$store.state.yearRange.min
                },
                set(value) {
                    this.$store.commit('setYearMin', parseInt(value))
                }
            },
            yearRangeMax: {
                get() {
                    return this.$store.state.yearRange.max
                },
                set(value) {
                    this.$store.commit('setYearMax', parseInt(value))
                }
            },
            queryLanguages() {
                return this.languageOptions.filter(lang => this.selectedLanguages.includes(lang.label)).map(l => l.id)
            },
            queryEcotypes() {
                this.$store.commit('setEcotypes', this.ecotypeOptions.filter(eco => this.selectedEcotypes.includes(eco.id)).map(e => e.id))
                return this.ecotypeOptions.filter(eco => this.selectedEcotypes.includes(eco.id)).map(e => e.id)
            },

            searchFieldProps() {
                // default properties
                let defaultProps = {
                    closeOnClick: false,
                    closeOnContentClick: false,
                    disableKeys: true,
                    openOnClick: false,
                    maxHeight: 300
                }

                // set maxHeight for mobile devices to avoid overflow
                // see: https://github.com/vuetifyjs/vuetify/issues/5950
                if (this.$vuetify.breakpoint.smAndDown) {
                    defaultProps.maxHeight = 150
                }
                return defaultProps
            },

            lang() {
                return i18n.locale
            },
            isFungusApp() {
                return this.$store.getters.isFungusApp
            },
            isLichenApp() {
                return this.$store.getters.isLichenApp
            },

        },

        watch: {
            yearRangeMin() {
                this.timeSlider = [this.$store.state.yearRange.min, this.$store.state.yearRange.max]
            },
            yearRangeMax() {
                this.timeSlider = [this.$store.state.yearRange.min, this.$store.state.yearRange.max]
            },

            timeSlider: debounce(function () {
                this.$store.commit('setYearMin', this.timeSlider[0])
                this.$store.commit('setYearMax', this.timeSlider[1])
                let url = process.env.BASE_URL + 'search?taxon=' + this.$store.state.taxonId + '&start=' + this.$store.state.yearRange.min + '&end=' + this.$store.state.yearRange.max + '&lang=' + this.$store.state.lang
                this.$store.commit('setQueryURL', url)
            }, 300),

            taxonName() {
                // use searchterm from store for cases where page is loaded using url params
                // this implies that the autocomplete label automatically displays the searchterm, if available
                this.searchTerm = this.$store.state.taxonName
                this.retrieveResult()
            },

            selectedEcotypes() {
                this.retrieveResult()

            },

            lang() {
                // reload ecotype options if another language is selected
                this.ecotypeOptions = this.getEcotypeOptions()

                // change no data message
                this.searchSuggestions = [this.$i18n.t('search.noDataMessage')]
            },

        },

        methods: {
            getParams(selected, queryParam) {
                let params = ''
                for (let i = 0; i < selected.length; i++) {
                    params = params + queryParam + selected[i] + '&'
                }
                return params
            },

            getEcotypeOptions() {
                // {id: 'U', label: i18n.t('search.selectU')}, // TODO: @Silvia: implicitely include U if all selected ?

                return [
                    {id: 'XXX', label: i18n.t('search.selectU')}, // null ecotypes
                    {id: 'E', label: i18n.t('search.selectE')},
                    {id: 'L', label: i18n.t('search.selectL')},
                    {id: 'S', label: i18n.t('search.selectS')},
                    {id: 'T', label: i18n.t('search.selectT')},
                ]
            },

            updateSearchTerm(event) {
                // clearable X icon in autocomplete yields undefined event:
                // https://github.com/vuetifyjs/vuetify/issues/5722
                if (event === undefined) {
                    this.clearSearchTerm()
                } else {
                    if (event.valueOf() !== null && event.valueOf() !== undefined && event.valueOf() !== '') {
                        this.searchTerm = event.valueOf()
                        this.$store.commit('setTaxonName', this.searchTerm)
                        this.retrieveResult()
                    }

                }
            },

            clearSearchTerm() {
                this.searchSuggestions = [i18n.t('search.noDataMessage')]
                this.searchTerm = ''
                this.$store.commit('setTaxonName', '')
                this.$store.commit('setTaxonId', null)
            },

            buildSearchUrl(wildcard) {
                if (this.searchTerm !== null && this.searchTerm !== undefined && this.searchTerm !== '') {
                    if (this.isFungusApp) {
                        return speciesUrl.speciesByName + wildcard + this.searchTerm.trim() + wildcard  + '?' + this.getParams(this.queryLanguages, 'lang=')
                    } else {
                        this.queryEcotypes
                        // currently only French and German vernacular names are represented in the LICHEN database. ("it" remains query parameter if Italian names are integrated in the future)
                        return speciesUrl.speciesByName + wildcard + this.searchTerm.trim() + wildcard  +  '?' + this.getParams(['de', 'fr', 'it'], 'lang=')
                    }
                } else {
                    return ''
                }
            },

            filterAbbreviations() {
                // always return true as matching conditions are already implemented im backend,
                // eg. NomenclatureHibernateDAO -> String queryExtended = query.replaceAll("\\s+", "%");
                // @TODO: fix highlighting of entire suggestion
                return true
            },

            search: debounce(function () {
                if (this.searchTerm !== null && this.searchTerm !== undefined && this.searchTerm.trim() !== '') {
                    this.searchSuggestions = [this.$i18n.t('search.noDataMessage')]

                    // use sql wildcard to match entire string
                    axios.get(this.buildSearchUrl('%25'))
                        .then((result) => {
                            let res = result.data

                            res.forEach(species => {
                                this.searchSuggestions.push(`${species.taxonName}${species.taxonAutor === null ? '' : ' ' + species.taxonAutor}`)
                            })

                            // display sorted list of suggestions
                            this.searchSuggestions.sort()

                        })
                        .catch((error) => {
                            console.log(API_ERROR_MESSAGE, error)
                        })
                } else {
                    this.clearSearchTerm()
                }
            }, 500),

            retrieveResult() {
                this.taxonName = this.searchTerm
                if (this.taxonName !== null && this.taxonName !== undefined && this.taxonName.trim() !== '') {

                    axios.get(this.buildSearchUrl(''))
                        .then((result) => {
                            this.$store.commit('setTaxonId', result.data[0].taxonId)
                            let url = process.env.BASE_URL + 'search?taxon=' + this.$store.state.taxonId + '&start=' + this.$store.state.yearRange.min + '&end=' + this.$store.state.yearRange.max + '&lang=' + this.$store.state.lang
                            this.$store.commit('setQueryURL', url)
                        })
                        .catch((error) => {
                            this.clearSearchTerm()
                            console.log(API_ERROR_MESSAGE, error)
                        })
                } else {
                    this.clearSearchTerm()
                }
            },

            expandSearchSettings() {
                this.showSearchSettings = !this.showSearchSettings
            },

            isMobile() {
                // set footer position style attribute to avoid overlapping in mobile setting
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs':
                        return true
                    case 'sm':
                        return true
                    case 'md':
                        return false
                    case 'lg':
                        return false
                    case 'xl':
                        return false
                    default:
                        return false
                }
            },
        },

        beforeMount() {
            this.ecotypeOptions = this.getEcotypeOptions()

            // set all available language (FUNGUS) | ecotype (LICHEN) options as default query parameters
            this.selectedLanguages = this.languageOptions.map(l => l.label)
            this.selectedEcotypes = this.ecotypeOptions.map(e => e.id)
        }
    }


</script>

<style scoped lang="scss">
    @import '../../../global';

    #app-search-header, #app-selected-timerange-header {
        color: $app-dark
    }

    #app-selected-search-languages, #app-selected-search-timerange {
        font-size: 11px;
        white-space: pre;

    }

    .app-search-bar-button {
        height: 55px !important;
        display: inline-block;
    }


</style>